import { render, staticRenderFns } from "./programDetails.vue?vue&type=template&id=4ff9466c&"
import script from "./programDetails.vue?vue&type=script&lang=js&"
export * from "./programDetails.vue?vue&type=script&lang=js&"
import style0 from "./programDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports